export function view (name) {
  return function (resolve) {
    require(['@/views/' + name + '.vue'], resolve)
  }
}



// WEBPACK FOOTER //
// ./src/configs/router/view.js